export const GOOGLE_MAPS_API_KEY = 'AIzaSyDyFZU7K_k-C10HtfTip3TUe6eZUY5gWzM';
// eslint-disable-next-line max-len
export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1Ijoibm9haGNvcm9uYSIsImEiOiJjbDV1YXYxMDEwYjF5M2RxNWZxamExb3VkIn0.xaPa7AKYZj1r8EhXFHTcxQ';
